import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

/**
 * MAINTENANCE API CONFIGURATION
 * Keys EXACTLY match controllers exposed by /api/v1/maintenance
 */
export const maintenanceConfig = {
  /* ------------------------------- GET ----------------------------------- */
  getMaintenanceRequests: {
    key: "getMaintenanceRequests",
    url: "/api/v1/maintenance/requests",
    method: "GET",
    options: {
      ...QUERY_PRESETS.SHORT,
      keepPreviousData: true,
    },
  },

  getMaintenanceById: {
    key: "getMaintenanceById",
    url: (data) => `/api/v1/maintenance/requests/${data.requestId || data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.SHORT,
    },
  },

  getMaintenanceTypes: {
    key: "getMaintenanceTypes",
    url: "/api/v1/master-data/maintenancetype?limit=100",
    method: "GET",
    options: {
      ...QUERY_PRESETS.STATIC,
    },
  },

  getMaintenanceStats: {
    key: "getMaintenanceStats",
    url: "/api/v1/maintenance/stats",
    method: "GET",
    options: {
      ...QUERY_PRESETS.SHORT,
    },
  },

  getMaintenanceLogs: {
    key: "getMaintenanceLogs",
    url: (data) =>
      `/api/v1/maintenance/requests/${data.maintenanceId || data.requestId || data.id}/logs`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.SHORT,
    },
  },

  getMaintenanceReports: {
    key: "getMaintenanceReports",
    url: "/api/v1/maintenance/reports",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  /* ------------------------------- POST ---------------------------------- */
  createMaintenanceRequest: {
    key: "createMaintenanceRequest",
    url: "/api/v1/maintenance/requests",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getMaintenanceRequests",
        "getMaintenanceStats",
        "getRooms",
        "getRoomTypes",
      ],
    },
  },

  /* ------------------------------- PUT/PATCH ----------------------------- */
  updateMaintenanceRequest: {
    key: "updateMaintenanceRequest",
    url: (data) =>
      `/api/v1/maintenance/requests/${data.maintenanceId || data.requestId || data.id}`,
    method: "PUT",
    options: {
      retry: 2,
      invalidateKeys: [
        "getMaintenanceRequests",
        "getMaintenanceById",
        "getRooms",
        "getRoomTypes",
      ],
    },
  },

  updateMaintenanceStatus: {
    key: "updateMaintenanceStatus",
    url: (data) =>
      `/api/v1/maintenance/requests/${data.id || data.maintenanceId || data.requestId}/status`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: [
        "getMaintenanceRequests",
        "getMaintenanceStats",
        "getMaintenanceById",
        "getMaintenanceLogs",
        "getRooms",
        "getRoomTypes",
      ],
    },
  },

  assignMaintenance: {
    key: "assignMaintenance",
    url: (data) =>
      `/api/v1/maintenance/requests/${data.maintenanceId || data.requestId || data.id}/assign`,
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getMaintenanceRequests",
        "getMaintenanceById",
        "getMaintenanceLogs",
      ],
    },
  },
};
